import { apiService } from './api';

export interface GeneratedReportEntry {
  id: string;
  template_id: string | null;
  template_name: string;
  facility_id: string | null;
  facility_name: string | null;
  client_id: string | null;
  client_name: string | null;
  generated_by_id: string | null;
  generated_by_name: string | null;
  created_at: string | null;
}

export class ReportsService {
  async listGenerated(limit = 10, facilityId?: string): Promise<GeneratedReportEntry[]> {
    return apiService.get<GeneratedReportEntry[]>(
      `/reports/generated?limit=${limit}${facilityId ? `&facility_id=${encodeURIComponent(facilityId)}` : ''}`
    );
  }

  async downloadInspectionReport(inspectionId: string): Promise<void> {
    // Use fetch directly to handle blob download, but reuse the shared auth
    // headers + base URL so the request carries the Supabase bearer token
    // (and any X-Act-As) and targets the correct backend host.
    const response = await fetch(
      `${apiService.getBaseUrl()}/reports/inspection/${inspectionId}`,
      {
        method: 'POST',
        headers: await apiService.authHeaders(),
      }
    );
    if (!response.ok) {
      throw new Error(`Failed to generate report: ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `InspectionReport-${inspectionId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}

export const reportsService = new ReportsService();
